import { IBienLaiViewTheoLopChiTietActionTypes } from "../../action-types/bien-lai/IBienLaiViewTheoLopChiTietActionTypes";
import {
  IBienLaiViewTheoLopChiTietReducer,
  IBienLaiViewTheoLopChiTietReducerItem,
} from "../../reducer-model/bien-lai/IBienLaiViewTheoLopChiTietReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IBienLaiViewTheoLopChiTietReducer = {
  bienLais: [],
};
export const bienLaiViewTheoLopChiTietReducer = (
  state: IBienLaiViewTheoLopChiTietReducer = iniState,
  action: IBienLaiViewTheoLopChiTietActionTypes
): IBienLaiViewTheoLopChiTietReducer => {
  switch (action.type) {
    case "BIEN_LAI_VIEW_THEO_LOP_CHI_TIET_LOAD_START":
      let obj_load_start = state.bienLais.find(
        (bienLai) => bienLai.so_phieu_group === action.payload
      );
      return {
        ...state,
        bienLais: [
          ...state.bienLais.filter(
            (bienLai) => bienLai.so_phieu_group !== action.payload
          ),
          {
            ...obj_load_start,
            so_phieu_group: action.payload,
            status: eReducerStatusBase.is_loading,
          },
        ],
      };
    case "BIEN_LAI_VIEW_THEO_LOP_CHI_TIET_LOAD_SUCCESS":
      return {
        ...state,
        bienLais: state.bienLais.map((bienLai) => {
          if (
            action.payload?.length > 0 &&
            bienLai.so_phieu_group === action.payload[0].so_phieu_group
          ) {
            return {
              ...bienLai,
              bienLaiViewModels: action.payload,
              status: eReducerStatusBase.is_completed,
            };
          }
          return bienLai;
        }),
      };
    case "BIEN_LAI_VIEW_THEO_LOP_CHI_TIET_LOAD_ERRR":
      return {
        ...state,
        bienLais: state.bienLais.map((bienLai) => {
          if (bienLai.so_phieu_group === action.payload.request) {
            return {
              ...bienLai,
              bienLaiViewModels: undefined,
              status: eReducerStatusBase.is_completed,
            };
          }
          return bienLai;
        }),
      };
    case "BIEN_LAI_VIEW_THEO_LOP_CHI_TIET_PRINT_START":
      let obj_print_start =
        state.bienLais.find(
          (bienLai) => bienLai.so_phieu_group === action.payload.id
        ) ?? {};
      return {
        ...state,
        bienLais: [
          ...state.bienLais.filter(
            (bienLai) => bienLai.so_phieu_group !== action.payload.id
          ),
          {
            ...obj_print_start,
            so_phieu_group: action.payload.id,
            status: eReducerStatusBase.is_completed,
            htmlTemplate: undefined,
            statusPrint: eReducerStatusBase.is_loading,
          },
        ],
      };

    case "BIEN_LAI_VIEW_THEO_LOP_CHI_TIET_PRINT_SUCCESS":
      return {
        ...state,
        bienLais:
          state.bienLais?.map((bienLai) => {
            if (bienLai.so_phieu_group === action.payload.request) {
              return {
                ...bienLai,
                htmlTemplate: action.payload.data,
                statusPrint: eReducerStatusBase.is_completed,
              };
            }
            return bienLai;
          }) ??
          ([
            {
              so_phieu_group: action.payload.request,
              htmlTemplate: action.payload.data,
              statusPrint: eReducerStatusBase.is_completed,
            },
          ] as IBienLaiViewTheoLopChiTietReducerItem[]),
      };
    case "BIEN_LAI_VIEW_THEO_LOP_CHI_TIET_PRINT_ERR":
      return {
        ...state,
        bienLais: state.bienLais.map((bienLai) => {
          if (bienLai.so_phieu_group === action.payload.request) {
            return {
              ...bienLai,
              htmlTemplate: undefined,
              statusPrint: eReducerStatusBase.is_completed,
            };
          }
          return bienLai;
        }),
      };
    default:
      return state;
  }
};
